import React, { useEffect } from 'react';
import Projects from '../components/projects/Projects';
import Header from '../components/projects/Header';
import { useLocation } from 'react-router-dom';

const ProjectPage = () => {

    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <div className='bg-gray-50 h-full'>
            <Header />

            <div className="container mx-auto p-2">
                <Projects />
            </div>
        </div>
    );
};

export default ProjectPage;